export default value => {
    value = Math.round(value * 100) / 100;
    
    let priceString = value + '';
    let priceArray  = priceString.split('.');
    
    if(priceArray.length == 0){
        priceArray.push('00');
    }
    
    if(priceArray.length == 1){
        priceArray.push('00');
    }

    if(priceArray[1].length < 2){
        priceArray[1] += '0';
    }

    priceArray[1] = priceArray[1].substring(0,2);
    let price       = priceArray.join(',') + ' €';
    
    return price;
}